export default "__VITE_ASSET__e166f6fc__"